import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BlogEntryDTO } from '../DTO/BlogEntryDTO';
import { Section } from './Section';
import { postPreview } from '../lib/format';

export function LatestBlogSection() {
    const [latestPost, setLatestPost] = useState<BlogEntryDTO | null>(null);

    useEffect(() => {
        fetch('/api/blog/latest')
            .then(res => { if (!res.ok) throw new Error(); return res.json(); })
            .then(data => setLatestPost(data))
            .catch(() => setLatestPost(null));
    }, []);

    if (!latestPost) return null;

    const preview = postPreview(latestPost.content);

    const formattedDate = new Date(latestPost.publishDate || '').toLocaleDateString('en-US', {
        month: 'long', day: 'numeric', year: 'numeric',
    });

    return (
        <Section
            title="Writing"
            aside={<Link to="/blog" className="link font-label">All posts</Link>}
        >
            <article className="max-w-[42rem]">
                <time dateTime={latestPost.publishDate} className="label">{formattedDate}</time>
                <h3 className="text-2xl mt-1 mb-3">
                    <Link to={`/blog/${latestPost.slug}`} className="hover:text-loden">
                        {latestPost.title}
                    </Link>
                </h3>
                <p className="text-muted m-0 mb-4">
                    {preview}
                </p>
                <Link to={`/blog/${latestPost.slug}`} className="link font-label">
                    Read the post<span className="sr-only">: {latestPost.title}</span>
                </Link>
            </article>
        </Section>
    );
}
